import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  profits: {}, // เก็บ profit แยกตาม symbol
  totalEquity: 0
};

const equitySlice = createSlice({
  name: 'equity',
  initialState,
  reducers: {
    updateProfit: (state, action) => {
      const { symbol, profit } = action.payload;
      state.profits[symbol] = profit;
      // คำนวณ total equity จากทุก profits
      state.totalEquity = Object.values(state.profits).reduce((sum, profit) => sum + profit, 0);
    },
    clearProfits: (state) => {
      state.profits = {};
      state.totalEquity = 0;
    }
  }
});

export const { updateProfit, clearProfits } = equitySlice.actions;
export default equitySlice.reducer;
